export default __webpack_public_path__ + "static/media/Planets - Preview 1.cb76a7f5.png";